/*
 *   File : phone-country-select.js
 *   Author : https://evoqins.com
 *   Description : phone-country-select modal
 *   Integrations : NA
 *   Version : 1.0.0
 *   Date : 25-05-2024
*/

import { memo, useEffect, useState } from 'react';
import { getCountries, getCountryCallingCode, parsePhoneNumber } from 'react-phone-number-input/input';
import countryNames from 'react-phone-number-input/locale/en';

// Components
import { CustomTextInput } from '../Form-Elements';
import { Icon } from '../Icon';
import { OverLay } from '../Other';

//custom styles
import Colors from "../../Style/color.scss";


function PhoneCountrySelectModal({ value, inputValue, selectedCountryCode, handleCountrySelect, disableCountrySelect, type, phoneInputWrapper, handleCloseModal }) {

    // Creating country object
    let country_list = getCountries().map((country, index) => (
        {
            id: index + 1,
            country_name: countryNames[country],
            country_locale: country,
            country_code: `+${getCountryCallingCode(country)}`,
            flag: `https://purecatamphetamine.github.io/country-flag-icons/3x2/${country}.svg`,
        }
    ));

    const [countries, setCountries] = useState(country_list);
    const [searchValue, setSearchValue] = useState("");
    const [showPhoneCountryDropDown, setShowPhoneCountryDropDown] = useState(false);

    useEffect(() => {
        if (showPhoneCountryDropDown && type !== 2) {
            document.querySelector(`#${phoneInputWrapper}`).scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [showPhoneCountryDropDown]);

    useEffect(() => {

        if (searchValue == "") {
            setCountries(country_list);
        } else {
            if (searchValue.length > 2) {
                let filtered_countries = countries.filter(country => (
                    country.country_name.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase())
                ));
                setCountries(filtered_countries);

            }
        }

    }, [searchValue]);

    // handle country select
    const _handleCountrySelect = (country) => {
        handleCountrySelect(country);
        setShowPhoneCountryDropDown(false);
        setSearchValue("");
        console.log("country select")
    };

    //handle search
    const _handleSearch = (value) => {
        if (value.trim().length == 0) {
            setSearchValue("");
            return;
        };
        setSearchValue(value);
    };

    // handle modal close
    const _handleOpenCountryModal = (event) => {
        setShowPhoneCountryDropDown(true);
        setSearchValue("");
        event.stopPropagation();
        event.preventDefault();
    };

    const _handleCloseDropDown = () => {
        setShowPhoneCountryDropDown(false);
        handleCloseModal();
    };


    return (
        <div id='phone-country-modal-wrapper' className={disableCountrySelect ? "pe-none" : ""} onClick={(e) => e.stopPropagation()} >
            {/* selected Country */}
            <span id='phone-country-select' className={`${inputValue ? "" : "e-text-lavender-gray"} cursor-pointer me-2 d-flex gap-1 align-items-center padding-12px-tb padding-12px-tb-res padding-12px-left  e-font-weight-500 e-font-14-res e-font-16`}
                onClick={_handleOpenCountryModal}>
                {"+" + getCountryCallingCode(value || (parsePhoneNumber(`${selectedCountryCode}${inputValue}`)?.country || "IN"))}
                <Icon icon="phone-dropdown-arrow"
                    className={showPhoneCountryDropDown ? "transform-rotate-180" : ""}
                    size={20}
                    color={inputValue ? Colors.dark_charcoal : Colors.lavender_gray} />
            </span>

            {/* Country dropdown modal */}
            {
                showPhoneCountryDropDown &&
                <>
                    <OverLay isOpen={true}
                        onClose={_handleCloseDropDown} />
                    <div id='phone-country-modal' className="z-index-99 position-absolute  start-0 top-100 p-3 pt-0 e-modal-box-shadow mt-2 e-border-radius-12  w-100 bg-white">
                        <div className="position-relative">

                            <div className="position-sticky top-0 bg-white pb-3 mb-1">
                                <h3 className="bg-white py-3 mb-3 e-border-bottom-1px-platinum-gray d-flex justify-content-between align-items-center e-text-charleston-green e-alt-font-poppins e-font-weight-600 e-font-14 line-height-24px">
                                    Select your country
                                    <Icon icon="close-btn-gray"
                                        size={32}
                                        color={Colors.chinese_black}
                                        className="cursor-pointer"
                                        onClick={_handleCloseDropDown} />
                                </h3>
                                <div className="position-relative mt-4">
                                    <CustomTextInput id="search-phone-country"
                                        type="text"
                                        autoFocus
                                        className="w-100 no-outline padding-12px-tb px-5 me-2"
                                        placeholder="Search by country name"
                                        inputWrapperClassName="e-border-1px-bright-gray"
                                        autoComplete="off"
                                        height="auto"
                                        value={searchValue}
                                        handleChange={_handleSearch} />
                                    <img src={require("../../Assets/Images/search-icon.svg").default}
                                        draggable={false}
                                        width={16}
                                        className="position-absolute top-50 translate-middle-y start-0 ms-2 ms-sm-3"
                                        alt="search" />
                                    {
                                        searchValue &&
                                        <span className="z-3 bg-white object-fit-contain position-absolute top-50 translate-middle-y end-0 me-2 cursor-pointer">
                                            <Icon icon="close-btn-gray"
                                                size={32}
                                                color={Colors.chinese_black}
                                                onClick={() => {
                                                    setSearchValue("");
                                                }} />
                                        </span>
                                    }
                                </div>
                            </div>

                            <div className="h-240 bg-white overflow-auto no-scrollbar">
                                {
                                    countries.length !== 0 ?
                                        countries.map((country, index) => (
                                            <div key={index + country}
                                                className="cursor-pointer padding-12px-tb e-border-bottom-1px-platinum-gray d-flex justify-content-between align-content-center"
                                                onClick={() => _handleCountrySelect(country.country_locale)}>
                                                <div className="d-flex gap-2 align-items-center">
                                                    <img className="object-fit-contain e-border-radius-4"
                                                        src={country.flag}
                                                        alt="country flag"
                                                        draggable="false"
                                                        width={32} />
                                                    <span className="e-text-black e-alt-font-poppins e-font-weight-400 e-font-14 line-height-22px ">
                                                        {country.country_name}({country.country_locale})
                                                    </span>
                                                </div>
                                                <span className="e-text-black e-alt-font-poppins e-font-weight-400 e-font-14 line-height-22px">
                                                    {country.country_code}
                                                </span>
                                            </div>
                                        ))
                                        :
                                        <p className='mt-5 text-center e-text-black e-alt-font-poppins e-font-weight-500 e-font-16 line-height-22px'>
                                            No countries found!
                                        </p>
                                }
                            </div>

                        </div>
                    </div>
                </>
            }
        </div>
    )
}

export default memo(PhoneCountrySelectModal);